import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Hero from './Hero';
import Popular from './Popular';
import Spaces from './Spaces';
import Feed from './Feed';
import Rail from './Rail';
import Newsletter from './Newsletter';
import CommunityCta from './CommunityCta';
import Publications from './Publications';
import Tools from './Tools';
import loadPortal from '../service/portalApi';
import loadSpaceFeed from '../service/spaceFeedApi';
export default class PortalPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    // Bootstrap payload исключает второй запрос при SSR; клиентский переход использует тот же публичный API.
    this.portal = app.data.devconnectPortal || null;
    this.activeTab = 'foryou';
    this.activeSpace = null;
    this.spaceFeed = null;
    this.spaceLoading = false;
    this.spaceError = false;
    this.leaderPeriod = 'week';
    this.loading = this.portal === null;
    if (this.loading) {
      loadPortal().then(response => {
        this.portal = response.data;
      }).catch(() => {
        this.portal = {
          stats: {},
          latest: [],
          popular: [],
          leaders: {
            week: [],
            month: []
          },
          spaces: [],
          publications: [],
          tools: [],
          editorChoice: null,
          popularPeriodDays: 7,
          configuration: {}
        };
      }).finally(() => {
        this.loading = false;
        m.redraw();
      });
    }
  }
  selectSpace(slug) {
    this.activeSpace = slug;
    this.spaceFeed = null;
    this.spaceError = false;
    if (!slug) {
      this.spaceLoading = false;
      return;
    }
    this.spaceLoading = true;
    loadSpaceFeed(slug).then(response => {
      // Пользователь мог выбрать другое пространство до ответа сети. Старый ответ
      // не должен подменить более новый фильтр и снова показать неверное количество.
      if (this.activeSpace === slug) this.spaceFeed = response.data;
    }).catch(() => {
      if (this.activeSpace === slug) this.spaceError = true;
    }).finally(() => {
      if (this.activeSpace === slug) this.spaceLoading = false;
      m.redraw();
    });
  }
  view() {
    if (this.loading) {
      return m('main.dc-container', m('div.dc-card.dc-empty', 'Загружаем данные сообщества…'));
    }
    const leaders = Array.isArray(this.portal.leaders) ? {
      week: this.portal.leaders,
      month: this.portal.leaders
    } : this.portal.leaders;
    return m('main.dc-portal-page', {
      'aria-labelledby': 'dc-portal-title'
    }, [Hero({
      stats: this.portal.stats,
      spaces: this.portal.spaces,
      configuration: this.portal.configuration || {}
    }), Popular({
      discussions: this.portal.popular,
      editorChoice: this.portal.editorChoice,
      periodDays: this.portal.popularPeriodDays
    }), m('section.dc-section.dc-section--tight#community', m('div.dc-container.dc-community', [Spaces({
      spaces: this.portal.spaces,
      activeSpace: this.activeSpace,
      onSpaceChange: space => {
        this.selectSpace(space);
      }
    }), Feed({
      portal: this.portal,
      spaces: this.portal.spaces,
      activeTab: this.activeTab,
      activeSpace: this.activeSpace,
      spaceFeed: this.spaceFeed,
      spaceLoading: this.spaceLoading,
      spaceError: this.spaceError,
      onTabChange: tab => {
        this.activeTab = tab;
      },
      onSpaceChange: space => {
        this.selectSpace(space);
      },
      onSpaceClear: () => {
        this.selectSpace(null);
      }
    }), Rail({
      leaders,
      period: this.leaderPeriod,
      onPeriodChange: period => {
        this.leaderPeriod = period;
      },
      stats: this.portal.stats
    })])), Publications({
      items: this.portal.publications || []
    }), Tools({
      items: this.portal.tools || []
    }), CommunityCta(), m(Newsletter)]);
  }
}
flarum.reg.add('devconnect-portal', 'forum/components/PortalPage', PortalPage);